import { useTranslation } from "react-i18next";
import { OldValue } from "../../../../../helpers/historyHelpers/components/OldValue";
import { NewValue } from "../../../../../helpers/historyHelpers/components/NewValue";
import { firstToUpper } from "../../../../../../../utils/helpers/string";
import { Label } from "../../../../../helpers/historyHelpers/components/Label";
import { renderSettingsResourceLabel } from "../../../../../../../utils/helpers/settings";

const fields = ["description", "rules", "status"];

const RenderItem = ({ data }) => {
    const { t } = useTranslation();

    if (!data) return null;

    const renderValues = (item, data) => {
        const newValue = data[item]?.new;
        const oldValue = data[item]?.old;

        switch (item) {
            case "description":
                return (
                    <>
                        {oldValue && <OldValue value={oldValue} />}
                        {newValue && <NewValue value={newValue} />}
                    </>
                );
            case "status":
                return (
                    <>
                        {oldValue && <OldValue value={firstToUpper(t(oldValue))} />}
                        {newValue && <NewValue value={firstToUpper(t(newValue))} />}
                    </>
                );
            case "rules":
                const formattedNewRules = (
                    <div className="d-flex flex-column">
                        {newValue.map((item, i) => {
                            return (
                                <div key={i} className="d-flex">
                                    {item?.type && (
                                        <span className="pr-2">
                                            {t("type")}: {t(item.type)},
                                        </span>
                                    )}
                                    {item?.amount && (
                                        <span className="pr-2">
                                            {t("amount")}: {item.amount},
                                        </span>
                                    )}
                                    {item?.payCode && (
                                        <span className="pr-2">
                                            {t("payCode")}: {renderSettingsResourceLabel(item.payCode)},
                                        </span>
                                    )}
                                    {typeof item?.status === "boolean" && (
                                        <span>
                                            {t("status")}: {item.status ? t("active") : t("inactive")}
                                        </span>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                );

                const formattedOldRules = (
                    <div className="d-flex flex-column">
                        {newValue.map((item, i) => {
                            return (
                                <div key={i}>
                                    {item?.type && (
                                        <span className="pr-2">
                                            {t("type")}: {t(item.type)},
                                        </span>
                                    )}
                                    {item?.amount && (
                                        <span className="pr-2">
                                            {t("amount")}: {item.amount},
                                        </span>
                                    )}
                                    {item?.payCode && (
                                        <span className="pr-2">
                                            {t("payCode")}: {renderSettingsResourceLabel(item.payCode)},
                                        </span>
                                    )}
                                    {typeof item?.status === "boolean" && (
                                        <span>
                                            {t("status")}: {item.status ? t("active") : t("inactive")}
                                        </span>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                );

                return (
                    <>
                        <OldValue value={formattedOldRules} />
                        <NewValue value={formattedNewRules} />
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="tooltip-content-style text-left">
            {fields?.map((item) => {
                if (!data[item]) return null;

                return (
                    <div>
                        <div className="py-1 d-flex align-items-center gap-2">
                            <Label value={t(item)} /> {renderValues(item, data)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default RenderItem;
